import { fetcher } from "utils";

export const get__v1__coordi__id = id => fetcher.get(`/api/v1/coordi/${id}`, { serializer: "v1" });
